var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages"},_vm._l((_vm.combinedMessages),function(message){return _c('el-alert',{key:message.id,attrs:{"title":message.text,"type":message.type,"show-icon":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }